import React, { type ReactElement } from 'react';

import { useFireExposureEvents } from '../hooks/analytics-handlers/useFireExposureEvents';
import { useOperationalInfo } from '../store/operationalStore';
import { useExperimentInfo } from '../store/experimentInfoStore';
import { useCloseModalEvents } from '../hooks/analytics-handlers/useCloseModalEvents';
import { isEotEnabled } from '../util/isEotEnabled';
import { useLoadCohortToStore } from '../hooks/load-to-store/useLoadCohortToStore';
import { statsigCohorts } from '../experimentConstants';

import { EotTrialInfo } from './EotTrialInfo';

export const useEndOfTrialModalExperiment = () => {
	const { error } = useOperationalInfo();
	const { cohort, shouldShowModal, epMessageReady } = useExperimentInfo();
	const { fireExposureEvents } = useFireExposureEvents();
	const { fireCloseModalEvents } = useCloseModalEvents();

	return {
		epMessageReady,
		error,
		shouldShowModal,
		cohort,
		fireCloseModalEvents,
		fireExposureEvents,
	};
};

export const EndOfTrialModalWrapper = ({ children }: { children: ReactElement }) => {
	const eotEnabled = isEotEnabled();
	const { cohort } = useExperimentInfo();

	useLoadCohortToStore();

	if (eotEnabled && cohort && cohort !== statsigCohorts.NON_ENROLLED) {
		return <EotTrialInfo>{children}</EotTrialInfo>;
	}

	return <>{children}</>;
};
